import commonHelper from '@/app/utility/common.helper.utility';
export default {
  name: 'commonItemModal',
  props: [
    'modalType',
    'vendorCode',
    'poNumber',
    'stateCode',
    'poLineNum',
    'legalEntityValue',
    'requestPara',
    'accountNum'
  ],
  components: {},
  watch: {
    currentPageItemType: function() {
      this.getItemTypeData();
    },
    perPageItemType: function() {
      this.currentPageItemType = 1;
      this.getItemTypeData();
    },
    currentPageItemCat: function() {
      this.getItemCategoryData();
    },
    perPageItemCat: function() {
      this.currentPageItemCat = 1;
      this.getItemCategoryData();
    },
    currentPageExpenseAcc: function() {
      this.getExpenseAccData();
    },
    perPageExpenseAcc: function() {
      this.currentPageExpenseAcc = 1;
      this.getExpenseAccData();
    },
    currentPageTemplate: function() {
      this.getTemplateData();
    },
    perPageTemplate: function() {
      this.currentPageTemplate = 1;
      this.getTemplateData();
    },
    currentPageUom: function() {
      this.getUomDetails();
    },
    perPageUom: function() {
      this.currentPageUom = 1;
      this.getUomDetails();
    },
    currentPageTaxRate: function() {
      this.getTaxRateDetails();
    },
    perPageTaxRate: function() {
      this.currentPageTaxRate = 1;
      this.getTaxRateDetails();
    },
    // Functions for PO Number automatic fill------------------->
    // selectAllCheckBox: function() {
    //   this.checkUncheckAllSelectBox();
    // }
  },
  data() {
    return {
      // Common Variables
      loader: false,
      // Legal Entity Form Variables
      perPageItemType: commonHelper.perPageRecord,
      pageOptionsItemType: commonHelper.getPageOption(),
      totalRowsItemType: null,
      currentPageItemType: 1,
      itemTypeData: [],
      itemTypeFields: [
        {
          key: 'lookup_code',
          label: 'Lookup Code'
        },
        {
          key: 'meaning',
          label: 'Lookup'
        }
      ],
      itemTypeSearch: null,
      // Period Form Variables
      perPageItemCat: commonHelper.perPageRecord,
      pageOptionsItemCat: commonHelper.getPageOption(),
      totalRowsItemCat: null,
      currentPageItemCat: 1,
      itemCatData: [],
      itemCatFields: [
        {
          key: 'cat',
          label: 'Category'
        }
      ],
      itemCatSearch: null,
      // Vendor Form Variables
      perPageExpenseAcc: commonHelper.perPageRecord,
      pageOptionsExpenseAcc: commonHelper.getPageOption(),
      totalRowsExpenseAcc: null,
      currentPageExpenseAcc: 1,
      expenseAccData: [],
      expenseAccFields: [
        {
          key: 'flex_value',
          label: 'Expense ID'
        },
        {
          key: 'description',
          label: 'Expense Account'
        }
      ],
      expenseAccSearch: '',
      // PO Number Form Variables
      perPageTemplate: commonHelper.perPageRecord,
      pageOptionsTemplate: commonHelper.getPageOption(),
      totalRowsTemplate: null,
      currentPageTemplate: 1,
      templateData: [],
      templateFields: [
        {
          key: 'temp_name',
          label: 'Template'
        },
        {
          key: 'description',
          label: 'Description'
        }
      ],
      templateSearch: '',
      // UOM Form Variables
      perPageUom: commonHelper.perPageRecord,
      pageOptionsUom: commonHelper.getPageOption(),
      totalRowsUom: null,
      currentPageUom: 1,
      uomData: [],
      uomFields: [
        {
          key: 'uom_code',
          label: 'UOM'
        },
        {
          key: 'unit_of_measure'
        }
      ],
      uomSearch: '',
      // TaxRate Form Variables
      perPageTaxRate: commonHelper.perPageRecord,
      pageOptionsTaxRate: commonHelper.getPageOption(),
      totalRowsTaxRate: null,
      currentPageTaxRate: 1,
      taxRateData: [],
      taxRateFields: [
        {
          key: 'reporting_code',
          label: 'Tax Rate Code'
        },
        {
          key: 'reporting_code_description',
          label: 'Tax Rate Description'
        }
      ],
      taxRateSearch: ''
    };
  },
  mounted() {
    if (this.modalType === 'item_type') {
      this.getItemTypeData();
    } else if (this.modalType === 'asset_cat') {
      this.getItemCategoryData();
    } else if (this.modalType === 'template') {
      this.getTemplateData();
    } else if (this.modalType === 'uom') {
      this.getUomDetails();
    } else if (this.modalType === 'expense_acc') {
      this.getExpenseAccData();
    } else if (this.modalType === 'tax_rate') {
      this.getTaxRateDetails();
    }
  },
  methods: {
    // Functions for Item Type Form
    getItemTypeData() {
      const payload = {
        _page: this.currentPageItemType - 1,
        _limit: this.perPageItemType,
        item_type: this.itemTypeSearch
      };
      this.loader = true;
      this.$store
        .dispatch('purchaseRequisition/getItemTypeData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data.page;
            this.itemTypeData = result;
            this.totalRowsItemType = resp.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedItemType(item) {
      this.$emit('mapSelectedVsetData', item);
    },
    clearItemType() {
      this.itemTypeSearch = null;
      this.getItemTypeData();
    },
    // Functions for Period Form
    getItemCategoryData() {
      const payload = {
        _page: this.currentPageItemCat - 1,
        _limit: this.perPageItemCat,
        cate: this.itemCatSearch,
      };
      this.loader = true;
      this.$store
        .dispatch('purchaseRequisition/getItemCategoryData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data.page;
            this.itemCatData = result;
            this.totalRowsItemCat = resp.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedItemCat(item) {
      this.$emit('mapSelectedVsetData', item);
    },
    clearItemCat() {
      this.itemCatSearch = null;
      this.getItemCategoryData();
    },
    // Functions for Vendor Form
    getExpenseAccData() {
      const payload = {
        _page: this.currentPageExpenseAcc - 1,
        _limit: this.perPageExpenseAcc,
        expense: this.expenseAccSearch,
      };
      this.loader = true;
      this.$store
        .dispatch('purchaseRequisition/getExpenseAccData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data.page;
            this.expenseAccData = result;
            this.totalRowsExpenseAcc = resp.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedExpenseAcc(item) {
      this.$emit('mapSelectedVsetData', item);
    },
    clearExpenseAcc() {
      this.expenseAccSearch = '';
      this.getExpenseAccData();
    },
    // Functions for PO Number Form
    getTemplateData() {
      const payload = {
        _page: this.currentPageTemplate - 1,
        _limit: this.perPageTemplate,
        template: this.templateSearch,
      };
      this.loader = true;
      this.$store
        .dispatch('purchaseRequisition/getTemplateData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data.page;
            this.templateData = result;
            this.totalRowsTemplate = resp.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelctedTemplate(item) {
      this.$emit('mapSelectedVsetData', item);
    },
    clearTemplate() {
      this.templateSearch = '';
      this.getTemplateData();
    },
    // Functions for PO Number automatic fill------------------->
    // checkUncheckAllSelectBox() {
    //   this.templateData = this.templateData.map(data => {
    //     data.selectBox = this.selectAllCheckBox;
    //     return data;
    //   });
    // },
    // selectedPoNumData() {
    //   const selectedPoNumber = this.templateData.filter(item => {
    //     if (item.selectBox) {
    //       return item;
    //     }
    //   });
    //   if (selectedPoNumber.length) {
    //     this.$emit('selectedPoNum', selectedPoNumber);
    //   } else {
    //     alert('Please Select Po Number');
    //   }
    // },

    // Functions for UOM Form
    getUomDetails() {
      const payload = {
        _page: this.currentPageUom - 1,
        _limit: this.perPageUom,
        uom: this.uomSearch
      };
      this.loader = true;
      this.$store
        .dispatch('purchaseRequisition/getUomDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data.page;
            this.uomData = result;
            this.totalRowsUom = resp.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedUom(item) {
      this.$emit('mapSelectedVsetData', item);
    },
    clearUom() {
      this.uomSearch = '';
      this.getUomDetails();
    },
    // Functions for Tax Rate Form
    getTaxRateDetails() {
      const payload = {
        _page: this.currentPageTaxRate - 1,
        _limit: this.perPageTaxRate,
        tax_rate: this.taxRateSearch
      };
      this.loader = true;
      this.$store
        .dispatch('purchaseRequisition/getTaxRateDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data.page;
            this.taxRateData = result;
            this.totalRowsTaxRate = resp.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedTaxRate(item) {
      this.$emit('mapSelectedVsetData', item);
    },
    clearTaxRate() {
      this.taxRateSearch = '';
      this.getTaxRateDetails();
    },
    // Common Functions
    clearVsetValues(vsetCode) {
      if (vsetCode === this.itemTypeSearch) {
        this.itemTypeSearch = null;
      } else if (vsetCode === this.itemCatSearch) {
        this.itemCatSearch = null;
      } else if (vsetCode === this.expenseAccSearch) {
        this.expenseAccSearch = null;
      } else if (vsetCode === this.vendorCodeSearch) {
        this.vendorCodeSearch = null;
      } else if (vsetCode === this.templateSearch) {
        this.templateSearch = '';
      } else if (vsetCode === this.uomSearch) {
        this.uomSearch = null;
      } else if (vsetCode === this.stateCodeSearch) {
        this.stateCodeSearch = null;
      } else if (vsetCode === this.costCenterSearch) {
        this.costCenterSearch = null;
      } else if (vsetCode === this.accNoSearch) {
        this.accNoSearch = null;
      } else if (vsetCode === this.subAccNoSearch) {
        this.subAccNoSearch = null;
      } else if (vsetCode === this.provisionNoSearch) {
        this.provisionNoSearch = null;
      } else if (vsetCode === this.lobSearch) {
        this.lobSearch = null;
      } else if (vsetCode === this.customerSearch) {
        this.customerSearch = null;
      } else if (vsetCode === this.taxCatSearch) {
        this.taxCatSearch = null;
      } else if (vsetCode === this.trxTypeSearch) {
        this.trxTypeSearch = null;
      } else if (vsetCode === this.taxRateSearch) {
        this.taxRateSearch = null;
      }
    }
  }
};